<div class="wholeScreen" *ngIf="isBusy">
</div>
<div *ngIf="isBusy" class="SpinnerContainer" data-cvent-id="spinner" data-reactid="120">
  <div class="SpinnerouterCircle Spinnercircle Spinnercircle" data-reactid="121"></div>
  <div class="SpinnermiddleCircle Spinnercircle Spinnercircle" data-reactid="122"></div>
  <div class="SpinnerinnerCircle Spinnercircle Spinnercircle" data-reactid="123"></div>
</div>
